const moveItem = <Item>(
  arr: Item[],
  fromIndex: number,
  toIndex: number,
): Item[] => {
  const newArray = [...arr];
  const [removedElement] = newArray.splice(fromIndex, 1);
  newArray.splice(toIndex, 0, removedElement);

  return newArray;
};

export default moveItem;
